import React from 'react';
import PropTypes from 'prop-types';

function AccountStatBar(props) {
    const {
        count,
        selectedAccount: {
            accountId,
            name,
        }
    } = props;
    const EMPTY = '';

    /**
     * Displays the account count wording
     * eg: Showing 140,282 Accounts
     * @returns the verbage to display accounts count
     */
    const getCountDisplayVerbose = () => {
        if (count) {
            return `Showing ${count.toLocaleString()} Account${count > 1 ? 's' : EMPTY}`;
        }
        return null;
    }

    return (
        <div className={'accounts-summary'}>
            <spanL>
                {accountId ? `Active Account: ${name || EMPTY} (#${accountId})` : null}
            </spanL>
            <span>
                {getCountDisplayVerbose()}
            </span>
        </div>
    );
}

AccountStatBar.propTypes = {
    selectedAccount: PropTypes.shape({
        accountId: PropTypes.string,
        name: PropTypes.string,
    }),
    count: PropTypes.number,
};

export default AccountStatBar;
